import {
  ROOT,
  TRAVEL_AGENT_GET_ALL_ACTIVE,
  TRAVEL_AGENT_GET_ALL,
  TRAVEL_AGENT_GET_ALL_DEACTIVE,
  TRAVEL_AGENT_CHANGE_LEVEL,
  TRAVEL_AGENT_ACTIVE,
  TRAVEL_AGENT_DEACTIVE
} from '@/_helpers/constant.js';
import { requestOptions, handleResponse } from '@/_helpers';

function getAllActive(params) {
  return fetch(ROOT + TRAVEL_AGENT_GET_ALL_ACTIVE, requestOptions.post(params))
    .then(handleResponse);
}

function getAllAgent() {
  return fetch(ROOT + TRAVEL_AGENT_GET_ALL, requestOptions.get())
    .then(handleResponse);
}

function getAllDeactive(params) {
  return fetch(ROOT + TRAVEL_AGENT_GET_ALL_DEACTIVE, requestOptions.post(params))
    .then(handleResponse);
}

function changeLevel(data) {
  return fetch(ROOT + TRAVEL_AGENT_CHANGE_LEVEL, requestOptions.post(data))
    .then(handleResponse);
}

function active(id) {
  return fetch(ROOT + TRAVEL_AGENT_ACTIVE + `/` + id, requestOptions.get())
    .then(handleResponse);
}

function deactive(data) {
  return fetch(ROOT + TRAVEL_AGENT_DEACTIVE, requestOptions.post(data))
    .then(handleResponse);
}

export const service = {
  getAllActive,
  getAllAgent,
  getAllDeactive,
  changeLevel,
  active,
  deactive
};